<dynamic-form
  *ngIf="formGroup && columns && columns.length > 0"
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [areaName]="areaName"
  [model]="model"
  [erroremessage]="erroremessage"
  [columns]="columns"
  (valueChange)="onChanged($event)"
  [noSubmit]="deactivateSave"
  (cancelChange)="cancel()"
  (submitChange)="save()"
  class="user-form">
  <ng-container class="fcContent">
    <div class="rols" *ngIf="rolesIsLodes">
      <ssg-select
        name="RolesId"
        [multiple]="true"
        [group]="formGroup"
        [label]="'ClientApp.GNR.User.Roles' | translate"
        apiName="Role"
        [required]="true"
        class="user-role"
        textFieldName="DisplayName"
        userClass="select-sm"
        (valueChange)="roleChanged()"
        valueFieldName="Id">
      </ssg-select>
      <ssg-input
        [required]="true"
        name="NewPassword"
        textType="password"
        minLength="3"
        (valueChange)="onChanged($event)"
        maxLength="128"
        [required]="true"
        userClass="select-sm"
        [group]="formGroup"
        [label]="'ClientApp.GNR.User.Password' | translate">
      </ssg-input>
      <ssg-input
        [required]="true"
        name="ConfirmPassword"
        textType="password"
        minLength="3"
        maxLength="128"
        [required]="true"
        userClass="select-sm"
        (valueChange)="onChanged($event)"
        [group]="formGroup"
        [label]="'ClientApp.GNR.User.confirmPassword' | translate">
      </ssg-input>
    </div>
  </ng-container>
  <ng-container class="content">
    <ssg-tabset class="tabcontentbox">
      <ssg-tab *ngIf="isAccessToAllBranches" [tabTitle]="'ClientApp.GNR.User.Branches' | translate">
        <editable-grid
          *ngIf="Branches.length > 0 && isOk4View"
          [DefaultValues]="DefaultValues"
          [columns]="Branches"
          [dataList]="model.Branches"
          [isAdd]="false"
          [isDelete]="false">
        </editable-grid>
      </ssg-tab>
      <ssg-tab [tabTitle]="'ClientApp.GNR.User.SalesSettings' | translate">
        <div class="page">
          <ssg-input
            name="rialDiscount"
            [label]="'ClientApp.GNR.User.RialDiscountAmount' | translate"
            [group]="formGroup"
            userClass="select-sm"
            textType="currency"
            [withComma]="true"
            hasClear="true"></ssg-input>
          <ssg-input
            name="percentDiscount"
            [label]="'ClientApp.GNR.User.PercentageDiscountAmount' | translate"
            [group]="formGroup"
            (input)="Discount()"
            userClass="select-sm"
            isDecimal="false"
            textType="currency"
            hasClear="true"></ssg-input>
        </div>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
